module.exports = __webpack_public_path__ + "static/img/diamond-lighting.da200706.svg";